export default __webpack_public_path__ + "static/media/clone1.0e923685.svg";